import React from 'react';
import NewNotes from './New/Container';

export const Notes = (props) => {
  return <NewNotes {...props} />;
};
